import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import ProgramsReducer from "./programs/ProgramsReducer";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  programs: ProgramsReducer,
});

export default persistReducer(persistConfig, rootReducer);
